module.exports = { id: "hearts", url: "/build/app/img/symbols.svg#hearts", viewBox: "", toString: function() { return this.url; } };